import React from 'react';

type YoutubeEmbedProps = {
    videoId: string;
    classNames: string;
    autoplay?: boolean;
    start?: number;
};

export const YoutubeEmbed = ({ videoId, classNames, autoplay, start = 0 }: YoutubeEmbedProps) => {
    return (
        <iframe
            className={classNames}
            src={`https://www.youtube-nocookie.com/embed/${videoId}?&iv_load_policy=3${
                autoplay ? '&autoplay=1&muted=1' : ''
            }&start=${start}`}
            allowFullScreen={true}
            frameBorder={0}
            allow="autoplay; encrypted-media"
        />
    );
};
